@use '../../styling/colors.scss' as *;

.Pre {
  color: $theme-color-text;
  margin: 0;
}
